// eslint-disable-next-line @typescript-eslint/triple-slash-reference,spaced-comment
/// <reference path="sefaria.d.ts" />

export function sefariaTextTypeTransformation(
  transformation: (text: string) => string,
): (text: sefaria.TextType) => sefaria.TextType {
  const recursive = (text: sefaria.TextType): sefaria.TextType => {
    if (Array.isArray(text)) {
      return text.map(recursive) as sefaria.TextType;
    }
    return transformation(text);
  };
  return recursive;
}

export function firstOrOnlyElement(text: sefaria.TextType): string {
  if (typeof text === "string") {
    return text;
  }
  return firstOrOnlyElement(text[0]);
}

export function equalJaggedArrays(
  hebrew: sefaria.TextType,
  english: sefaria.TextType,
  predicate = (a: string, b: string) => a === b): boolean {
  if (Array.isArray(hebrew) && Array.isArray(english)) {
    if (hebrew.length !== english.length) {
      return false;
    }
    for (let i = 0; i <= hebrew.length; i++) {
      if (!equalJaggedArrays(hebrew[i], english[i])) {
        return false;
      }
    }
    return true;
  }

  return predicate(hebrew as string, english as string);
}

export function flatten(textType: sefaria.TextType): string | undefined {
  if (!textType) return undefined;
  if (typeof textType === "string") {
    return textType;
  }
  return textType.flat(Infinity).join("\n");
}

export function toFlatArray(textType: sefaria.TextType): string[] {
  if (!textType) return [];
  if (typeof textType === "string") {
    return [textType];
  }
  return textType.flat(Infinity);
}
